package devxertech.com.pages.portfolio

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2

@Page("/portfolio")
@Composable
fun PortfolioScreen() {
    PageMetadataForCurrentRoute()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            mainHeadingAsH1 = true,
            image = Res.Image.portfolio_header,
            imageAlt = "Devxer Technologies portfolio",
            breakpoint = breakpoint,
            headingText = "Our Portfolio",
            descriptionText = "Showcasing our work throughout the years",
            startProject = false, careerHeight = true, careerFontSize = true,
            heightModification = true,  careerHeaderText = true, commonPortfolioChanges = true
        )
        CommonArrow("Portfolio")
        Column(
            modifier = Modifier.fillMaxWidth().margin(topBottom = 20.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "OUR WORK",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint <= Breakpoint.LG) 15.px else 18.px
            )
            H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                    FieldTitleTextNormalSimple(
                        "HIGHLIGHTING THE",
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = if (breakpoint <= Breakpoint.LG) 20.px else 30.px,
                        fontWeight = 700,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        " TALENT AND EXPERTISE ",
                        color = sitePalette.primary.rgb,
                        fontSize = if (breakpoint <= Breakpoint.LG) 20.px else 30.px,
                        fontWeight = 700,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "THAT DRIVES US",
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = if (breakpoint <= Breakpoint.LG) 20.px else 30.px,
                        fontWeight = 700
                    )
            } }
            Row(
                modifier = Modifier.fillMaxWidth(if (breakpoint > Breakpoint.LG) 97.percent else 100.percent)
                    .margin(topBottom = if (breakpoint < Breakpoint.MD) 10.px else 30.px)
                    .flexWrap(FlexWrap.Wrap)
                    .columnGap(if (window.screen.width in 1200..1400) 9.px else if (window.screen.width == 1440) 50.px else  80.px)
                    .padding(
                        left = when {
                            window.screen.width >= 1640 -> 12.percent
                            else -> 0.percent
                        }
                    ),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (window.screen.width < 800) Arrangement.Center else Arrangement.Start
            ) {
                CommonPortfolioBox(
                    image = Res.Image.zone360_portfolio,
                    title = "Zone360",
                    path = "/zone"
                )
                CommonPortfolioBox(
                    image = Res.Image.safe_deposit_portfolio,
                    title = "Safe Deposit",
                    path = "/safeDeposit"
                )
                CommonPortfolioBox(
                    image = Res.Image.tcld,
                    title = "TCLD",
                    path = "/tcld"
                )
                CommonPortfolioBox(
                    image = Res.Image.varcity_portfolio,
                    title = "Varcity",
                    path = "/varcity"
                )
                CommonPortfolioBox(
                    image = Res.Image.aura_network_porfolio,
                    title = "Aura Network",
                    path = "/auraNetwork"
                )
            }
        }
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)


    }
}
